import React, { FC } from 'react'
import mail from '../../../../../public/static/images/svg/SVGMailFill.svg'
import phone from '../../../../../public/static/images/svg/SVGPhoneFill.svg'
import whatsapp from '../../../../../public/static/images/svg/SVGWhatsappFill.svg'
import { Box } from '../../../UI'
import * as ContactInformationItemStyles from './ContactInformationItem.styles'

type ContactInformationItemProps = React.ComponentPropsWithoutRef<"div"> & {
  type: 'mail' | 'phone' | 'whatsapp'
  href: string
}

const contactIcon = {
  mail: mail,
  phone: phone,
  whatsapp: whatsapp
}

const ContactInformationItem: FC<ContactInformationItemProps> = props => {
  const { type, href, children, style } = props
  return (
    <ContactInformationItemStyles.Container style={style}>
      <a href={href}>
        <Box
          alignItems="center"
          flexDirection={['row', 'column']}
          fontSize={['12px', '16px']}
          margin={['10px', 0]}
          width={['260px', 'auto']}
        >
          <ContactInformationItemStyles.Image src={contactIcon[type]}></ContactInformationItemStyles.Image>
          <Box textAlign={['left', 'center']}>{children}</Box>
        </Box>
      </a>
    </ContactInformationItemStyles.Container>
  )
}

export default ContactInformationItem
